export default __webpack_public_path__ + "static/media/CA-8 Grant required permissions.cc6bec76.png";